import React from 'react';
import './SortingButton.css';
import { PATH } from '../../../../../constants';

class SortingButton extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.sortingSwitch(this.props.buttonId);
  }

  render() {
    const { buttonId, sorting } = this.props;
    const btnClass = `btn-sort ${buttonId === sorting ? 'selected' : 'unselected'} ${buttonId % 2 === 0 ? 'dn' : 'up'}`;
    return (
      <button
        className={btnClass}
        onClick={this.handleClick}
      >
        <img
          className="ico"
          src={`${PATH.IMG}ico/ico-sort.png`}
          alt={buttonId % 2 === 0 ? 'Sestupně' : 'Vzestupně'}
        />
      </button>
    );
  }
}

export default SortingButton;



// WEBPACK FOOTER //
// ./src/components/App/CategoryPage/SortingMenu/SortingButton/SortingButton.js